import { useState } from "react";
import styles from "./FormsView.module.scss";
import { Pagination, View, ViewHeader } from "@/components";
import { FormExportModal, FormsApplicationsList, FormsToolbar } from "..";
import { useFormsApplicationsQuery } from "../../_hooks/useFormsApplicationsQuery";
import { useFormsApplicationsStore } from "../../_store/useFormsApplications.store";

export const FormsView = () => {
  const type = useFormsApplicationsStore((state) => state.type);
  const period = useFormsApplicationsStore((state) => state.period);
  const status = useFormsApplicationsStore((state) => state.status);
  const search = useFormsApplicationsStore((state) => state.search);
  const page = useFormsApplicationsStore((state) => state.page);
  const limit = useFormsApplicationsStore((state) => state.limit);
  const setType = useFormsApplicationsStore((state) => state.setType);
  const setPeriod = useFormsApplicationsStore((state) => state.setPeriod);
  const setStatus = useFormsApplicationsStore((state) => state.setStatus);
  const setSearch = useFormsApplicationsStore((state) => state.setSearch);
  const setPage = useFormsApplicationsStore((state) => state.setPage);
  const setLimit = useFormsApplicationsStore((state) => state.setLimit);
  const { data, isLoading, isFetching, isError, refetch } = useFormsApplicationsQuery();
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  const applications = data?.items ?? [];
  const meta = data?.meta ?? {
    total: 0,
    page,
    limit,
    totalPages: 1,
  };

  return (
    <View>
      <div className={styles["comp__content"]}>
        <ViewHeader
          heading="Forms"
          description="Browse submitted forms and follow up on incoming requests.<br />Use this section to organize and process form-based communication."
        />

        <FormsToolbar
          type={type}
          period={period}
          status={status}
          search={search}
          onTypeChange={setType}
          onPeriodChange={setPeriod}
          onStatusChange={setStatus}
          onSearchChange={setSearch}
          onExportClick={() => setIsExportModalOpen(true)}
        />

        <FormsApplicationsList
          applications={applications}
          isLoading={isLoading}
          isFetching={isFetching}
          isError={isError}
          onRetry={() => refetch()}
        />

        {meta.total > 0 && (
          <Pagination
            page={meta.page}
            limit={meta.limit}
            total={meta.total}
            totalPages={meta.totalPages}
            onPageChange={setPage}
            onRowsPerPageChange={setLimit}
          />
        )}

        <FormExportModal
          isOpen={isExportModalOpen}
          type={type}
          period={period}
          status={status}
          search={search}
          onClose={() => setIsExportModalOpen(false)}
        />
      </div>
    </View>
  );
};
